import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import Skeleton from '../../../Shared/Skeleton';

import TradeValue from './TradeValue';

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const CarValueWrapper = styled.div`
  position: relative;
  height: ${props => (props.hasTrade ? '180px' : '66px')};
`;

const SkeletonWrapper = styled.div`
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.34);
  height: 61px;
  margin: 1px 20px;
  padding: 10px;
  width: 212px;
  position: absolute;
  top: 0;
  left: 0;

  opacity: ${props => (props.isShown ? '1;' : '0;')};
  ${props => props.animation};
`;

const SkeletonSub = styled.div`
  width: 76px;
`;

const CarValue = ({ hasFetchedData, trade, tradeRequestInProgress }) => {
  const shouldShowAnimation = tradeRequestInProgress || hasFetchedData;
  const animation =
    shouldShowAnimation &&
    css`
      animation: ${fadeOut} 250ms ease-in;
    `;
  const hasTrade = trade && trade.hasTrade;
  return (
    <CarValueWrapper hasTrade={hasTrade}>
      <SkeletonWrapper isShown={tradeRequestInProgress} animation={animation}>
        <Skeleton />
        <SkeletonSub>
          <Skeleton />
        </SkeletonSub>
      </SkeletonWrapper>

      {tradeRequestInProgress ? null : (
        <TradeValue hasFetchedData={hasFetchedData} />
      )}
    </CarValueWrapper>
  );
};

CarValue.defaultProps = {
  trade: null
};

CarValue.propTypes = {
  hasFetchedData: PropTypes.bool.isRequired,
  trade: PropTypes.shape({}),
  tradeRequestInProgress: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  // note(oscar): am I missing a trade property? Track down the reducer.
  trade: state.header.header.trade,
  tradeRequestInProgress: state.header.header.tradeRequestInProgress
});

export default connect(mapStateToProps)(CarValue);
